export default {

    apiAddLead(data) {
        return this.request(this.api().ADD_LEAD, data).exec().log().get();
    },

    // (POST API CALL WITH QUERY PARAMETERS)
    apiAddCustomerLead(urldata = {}, data) {
        return this.request(this.api().ADD_LEAD, data, {}, urldata)
            .exec()
            .log()
            .get();
    },

    apiGetLeads(data) {
        let payload = {
            ...data
        };
        return this.request(this.api().GET_LEADS, payload)
            .exec().log()
            .mapresults((response) => {
                return {
                    data: response?.data,
                    total: response?.count
                }
            })
            .get();
    },

    apiGetLeadsByStatus(data) {
        let payload = {
            ...data
        };
        return this.request(this.api().GET_LEADS_BY_STATUS, payload)
            .exec().log()
            .mapresults((response) => {
                return {
                    data: response?.data,
                    total: response?.total
                }
            })
            .get();
    },

    apiGetLeadCountByStatus(data) {
        let payload = {
            ...data
        };
        return this.request(this.api().GET_LEAD_COUNT_BY_STATUS, payload)
            .exec().log()
            .mapresults((response) => {
                return {
                    data: response?.data,
                    total: response?.totalLeads
                }
            })
            .get();
    },

    apiGetLeadsAssignedByCounts(data) {
        let payload = {
            ...data
        };
        return this.request(this.api().GET_LEADS_ASSIGNED_BY_COUNTS, payload)
            .exec().log()
            .mapresults((response) => {
                return {
                    data: response?.data,
                    total: response?.total
                }
            })
            .get();
    },

    apiGetLeadsDashboardInfo(data) {
        let payload = {
            ...data
        };
        return this.request(this.api().GET_LEAD_DASHBOARD_INFO, payload)
            .exec().log()
            .mapresults((response) => {
                return response
            })
            .get();
    },

    apiGetLeadsById(urldata = {}) {
        urldata = { ...mixins.params(), ...urldata };
        return this.request(this.api().GET_LEADS_BY_ID,)
            .urltransform(urldata)
            .exec()
            .log()
            .mapresults((res) => {
                return res
            })
            .get();
    },

    apiGetLeadsOverallMetrics(data, urldata = {}) {
        return this.request(this.api().GET_LEADS_OVERALL_METRICS, data)
            .urltransform(urldata)
            .exec()
            .log()
            .mapresults((res) => {
                return res
            })
            .get();
    },
    apiExportLeads(data) {
        let payload = {
            ...data,
        };
        return this.request(this.api().EXPORT_LEADS, payload)
            .responsetype("arraybuffer")
            .exec()
            .log()
            .mapresults((response) => {
                return response;
            })
            .get();
    },
    apiExportLeadsAssignedByMe(data) {
        let payload = {
            ...data,
        };
        return this.request(this.api().EXPORT_LEADS_ASSIGNED_BY_ME, payload)
            .responsetype("arraybuffer")
            .exec()
            .log()
            .mapresults((response) => {
                return response;
            })
            .get();
    },

    apiUpdateLead(data, urldata = {}) {
        urldata = { ...mixins.params(), ...urldata };

        let payload = {
            ...data
        }
        payload = Object.filter(payload, (v) => v);

        return this.request(this.api().UPDATE_LEAD, payload).urltransform(urldata).exec().log().get();
    },

    apiUpdateOpsLead(data, urldata = {}) {
        urldata = { ...mixins.params(), ...urldata };

        let payload = {
            ...data
        }
        payload = Object.filter(payload, (v) => v);

        return this.request(this.api().UPDATE_OPS_LEAD, payload).urltransform(urldata).exec().log().get();
    },

    apiDeleteLead(urldata = mixins.params()) {

        return this.request(this.api().DELETE_LEAD)
            .urltransform(urldata)
            .exec().log().get();
    },

    apiDeleteBulkLeads(data) {

        return this.request(this.api().DELETE_BULK_LEADS, data)
            .exec().log().get();
    },

    apiAssignDeptToLead(data) {
        return this.request(this.api().ASSIGN_DEPT_TO_LEAD, data)
            .exec()
            .log()
            .get();
    },

    apiAssignSingleLead(data, urldata = {}) {
        return this.request(this.api().ASSIGN_SINGLE_LEAD, data)
            .urltransform(urldata)
            .exec()
            .log()
            .get();
    },

    apiGetLeadHistory(data) {
        let payload = {
            ...data
        };
        return this.request(this.api().GET_LEAD_HISTORY)
            .exec().log()
            .mapresults((response) => {
                return response
            })
            .get();
    },

    // BULK FILES
    apiBulkUploadLead(data, urldata = mixins.params()) {
        return this.request(this.api().BULK_UPLOAD_LEAD, data)
            .urltransform(urldata)
            .multipart()
            .exec()
            .log()
            .get();
    },
    apiDownloadLeadsTemplate() {
        return this.request(this.api().DOWNLOAD_LEADS_TEMPLATE)
            .urltransform({})
            .geturl();
    },
    apiBulkDownloadLead(data) {
        return this.request(this.api().DOWNLOAD_LEADS_LISTS, data)
            .exec()
            .log()
            .get();
    },
    apiReassignLeads(data) {
        return this.request(this.api().REASSIGN_LEADS, data)
            .exec()
            .log()
            .get();
    },
}